/**
 * Carries a «render a SurfaceView by (viewId, instanceKey)» closure into
 * dockview panels (架构方案 §5.7 视图多实例). Mirrors {@link AreaContentContext}:
 * dockview only forwards serializable `params`, so the heavy per-render
 * dependencies (registry / moduleService / bridges / subscribe*) that a
 * `SurfaceView` needs cannot go through params — this Context is the bridge.
 *
 * The closure is built in `layout.tsx` (where those deps live) and consumed by
 * the `surfaceTab` panel in `panels.tsx`, which is how a tabbed area
 * (`auxiliaryBar`) hosts multiple view instances as native dockview tabs while
 * staying module-agnostic: the area only knows «render this view instance», not
 * anything about chat sessions.
 */
import type { ReactNode } from 'react';
import { createContext } from 'react';

export const SurfaceHostContext = createContext<
  (viewId: string, instanceKey?: string) => ReactNode
>(() => null);
